import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "firebase/app";
import FooterComponent from "@/components/FooterComponent";
import RouterViewComponent from "@/components/RouterViewComponent";
import Home from "@/views/Home";
import DataProtectionView from "@/views/DataProtectionView";
import ImprintView from "@/views/ImprintView";
import UserLogin from "@/views/UserLogin";
import UserProfile from "@/views/UserProfile";
import UserPasswordReset from "@/views/UserPasswordReset";
import UserRegister from "@/views/UserRegister";
import ProjectsView from "@/views/ProjectsView";
import ProjectView from "@/views/ProjectView";
import NutrientBalance from "@/views/NutrientBalance";
import PlantProduction from "@/views/PlantProduction.vue";
import AnimalProduction from "@/views/AnimalProduction.vue";
import DemandsView from '@/views/DemandsView.vue';
import DemandFulfillment from "@/views/DemandFulfillment";
import CreateProject from "@/views/CreateProject";
import store from "@/store/index";

Vue.use(VueRouter);

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
const routes = [
  {
    path: "/",
    name: "Home",
    components: {
      default: Home,
      footer: FooterComponent,
    },
  },

  {
    path: "/info",
    components: {
      default: RouterViewComponent,
      footer: FooterComponent,
    },
    children: [
      {
        path: "data-protection",
        name: "DataProtection",
        components: {
          default: DataProtectionView,
        },
      },
      {
        path: "imprint",
        name: "Imprint",
        component: ImprintView,
      },
    ]
  },

  {
    path: "/user",
    components: {
      default: RouterViewComponent,
      footer: FooterComponent,
    },
    children: [
      {
        path: "login",
        name: "UserLogin",
        component: UserLogin,
      },
      {
        path: "register",
        name: "UserRegister",
        component: UserRegister,
      },
      {
        path: "reset",
        name: "UserPasswordReset",
        component: UserPasswordReset,
      },
      {
        path: "profile",
        name: "UserProfile",
        component: UserProfile,
      },
    ],
  },

  {
    path: "/projects",
    component: RouterViewComponent,
    meta: { auth: true },
    children: [
      {
        path: "list",
        name: "Projects",
          component: ProjectsView,
          beforeEnter: (to, from, next) => {
          if (to ||from ||next) { // make lint happy
            store.commit('setPageTitle', "Meine Projekte");
          }
          next();
        },
      },
      {
        path: "new",
        name: "NewProject",
        component: CreateProject,
      },
      {
        path: ":project_id",
        name: "Project",
        component: ProjectView,
        props: true,
        children: [
          {
            path: "plant",
            component: PlantProduction
          },
          {
            path: "animal",
            component: AnimalProduction,
            beforeEnter: (to, from, next) => {
              if (to ||from ||next) { // make lint happy
                next();
              }
            }
          },
          {
            path: "balance",
            component: NutrientBalance
          },
          {
            path: "fulfillment",
            component: RouterViewComponent,
            children: [
              {
                path: "list",
                component: DemandsView
              },
              {
                path: ":fulfillment_idx",
                component: DemandFulfillment
              }
            ]
          },
        ]
      }
    ]
  },

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const auth = firebase.auth();
// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
  
  store.commit('setPageTitle', null);

  //const publicPages = ['/', '/user/login', '/user/register', '/user/reset'];
  const authRequired = to.matched.some(m => m.meta.auth)

  if (authRequired && !auth.currentUser) {
    return next("/user/login");
  }

  return next();
});

export default router;
